import script from "./GlobalUppyUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalUppyUploader.vue?vue&type=script&setup=true&lang=js"

import "./GlobalUppyUploader.vue?vue&type=style&index=0&id=061c2790&scoped=true&lang=css"
import "./GlobalUppyUploader.vue?vue&type=style&index=1&id=061c2790&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061c2790"]])

export default __exports__